import React from "react";
import { Box, Typography } from "@mui/material";
import SpecialCard from "../../card/SpecialCard";

const DetailCard = ({ title, preTitle, content, footer, ...props }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {preTitle}
      {title}
      {content}
      {footer}
    </Box>
  );
};

export default DetailCard;
